import React from 'react'
import { StatusBadge } from './StatusBadge'

interface RadioOption {
	value: string
	label: string
	imageDesk?: string
	imageMob?: string
	disabled?: boolean
	loaded?: boolean
}

interface CustomRadioGroupProps {
	name: string
	options: RadioOption[]
	selectedValue: string
	minH?: string
	colsDesktop?: string
	labelPaddingClass?: string
	onChange: (value: string) => void
}

const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
	name,
	options,
	selectedValue,
	minH = 'min-h-[57px]',
	colsDesktop = 'md:grid-cols-3',
	labelPaddingClass = 'pl-4',

	onChange,
}) => {
	const computedCols =
		options.length === 2
			? 'md:grid-cols-2'
			: options.length === 1
				? 'md:grid-cols-1'
				: colsDesktop

	return (
		<div className='w-full'>
			<div
				className={`grid grid-cols-1 ${computedCols} gap-4 md:gap-6 w-full my-2.5`}
			>
				{options.map((option, key) => (
					<label
						key={key}
						className={`md:min-h-20 ${minH} md:max-h-[115.22px] flex items-center  ${labelPaddingClass} pr-1 md:py-2 rounded-2xl cursor-pointer transition border-2 md:border-3
						${
							option.loaded
								? 'bg-white border-(--crayon-green)'
								: selectedValue === option.value
									? 'bg-(--green-light) border-(--green-default) hover:bg-(--green-light)'
									: 'bg-white border-(--strokes-grey) hover:border-(--brand-green)'
						}`}
					>
						{!option.loaded && (
							<input
								type='radio'
								name={name}
								value={option.value}
								checked={selectedValue === option.value}
								onChange={(e) => onChange(e.target.value)}
								className='card-radio shrink-0 mr-2.5'
								disabled={option.disabled}
							/>
						)}
						{/* <input
							type='radio'
							name={name}
							value={option.value}
							checked={selectedValue === option.value}
							onChange={(e) => onChange(e.target.value)}
							className='card-radio'
							disabled={option.disabled}
						/> */}

						<span
							className={`flex-1 min-w-0 text-base leading-tight ${
								selectedValue === option.value ? 'font-semibold' : 'font-normal'
							}`}
						>
							{option.label}
						</span>

						{/* 
						<span
							className={`flex-1 text-base ${
								selectedValue === option.value ? 'font-semibold' : 'font-normal'
							}`}
						>
							{option.label}
						</span> */}
						{option.loaded && (
							<span className='ml-3 mr-2.5 shrink-0'>
								<StatusBadge status={true} />
							</span>
						)}

						{option.imageDesk && (
							<>
								{/* Mobile image */}
								<img
									src={option.imageMob}
									alt={option.label}
									className='max-h-12 w-auto max-w-[40%] object-contain pr-1 block md:hidden'
								/>

								{/* Desktop image — max-w caps width so it shrinks on narrow cards (e.g. iPad) */}
								<img
									src={option.imageDesk}
									alt={option.label}
									className='max-h-[90px] w-auto max-w-[45%] object-contain pr-4 hidden md:block'
								/>
							</>
						)}
					</label>
				))}
			</div>
		</div>
	)
}

export default CustomRadioGroup
